import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

const cardsGrid = document.getElementById("products-index");
gsap.registerPlugin(ScrollToPlugin);

const scrollToTop = (element) => {

	if (element) {
		gsap.to(window, { duration: 0.3, scrollTo: "#products-index", delay: 0.1 });
	}
}

// Pagination helpers actions
export const handleIncrementPage = (currentPageNumber, setParams, totalPages, event) => {
	event.preventDefault();
	if (currentPageNumber < totalPages.length) {
		setParams((currentValue) => {
			const searchParams = new URLSearchParams(currentValue.toString());
			searchParams.set("pageNumber", currentPageNumber + 1);
			return searchParams;
		});
		scrollToTop(cardsGrid);
	}
};
export const handleDecrementPage = (currentPageNumber, setParams, event) => {
	event.preventDefault();
	if (currentPageNumber > 1) {
		setParams((currentValue) => {
			const searchParams = new URLSearchParams(currentValue.toString());
			searchParams.set("pageNumber", currentPageNumber - 1);
			return searchParams;
		});
		scrollToTop(cardsGrid);
	}
};

export const handleButtonPageSelect = (buttonNumber, setParams, event) => {
	event.preventDefault();
	setParams((currentValue) => {
		const searchParams = new URLSearchParams(currentValue.toString());
		searchParams.set("pageNumber", buttonNumber);
		return searchParams;
	});
	scrollToTop(cardsGrid);
};